<template>
  <div v-if="showBanner" class="environment-banner" :class="bannerClass">
    <div class="banner-content">
      <span class="banner-icon">🚧</span>
      <span class="banner-text">{{ config.name }}</span>
      <span class="banner-version">v{{ appVersion }}</span>
    </div>
  </div>
</template>

<script>
import { config, isDevelopment, isStaging } from '@/config/environment';

export default {
  name: 'EnvironmentBanner',
  data() {
    return {
      config,
      appVersion: process.env.VUE_APP_VERSION || '1.0.0'
    };
  },
  computed: {
    showBanner() {
      return isDevelopment || isStaging;
    },
    bannerClass() {
      return {
        'development': isDevelopment,
        'staging': isStaging
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.environment-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: white;
  
  &.development {
    background: linear-gradient(90deg, #ff6b6b, #ff8e8e);
  }
  
  &.staging {
    background: linear-gradient(90deg, #feca57, #ff9ff3);
  }
  
  .banner-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  .banner-icon {
    font-size: 16px;
  }
  
  .banner-text {
    font-weight: 700;
  }
  
  .banner-version {
    opacity: 0.8;
    font-size: 12px;
  }
}

// 当横幅显示时，调整主内容区域
:deep(body) {
  &.has-environment-banner {
    padding-top: 40px;
  }
}
</style> 